import './SiteAnnouncements.scss';
import * as React from 'react';
import { Link } from 'components/core';
import { graphql, StaticQuery } from 'gatsby';
import { unwrapQuery, Query } from 'types/queries';
type Props = {
  data: {
    announcements: Query<{
      id: string;
      visibleStartDate: Date;
      visibleEndDate: Date;
      title: string;
      details: string;
      url: string;
    }>;
  };
};
type State = {
  now: number;
};
class SiteAnnouncements extends React.Component<Props, State> {
  state = {
    now: Date.now(),
  };
  ticker: IntervalID | undefined | null = null;
  componentDidMount() {
    this.ticker = setInterval(() => {
      this.setState({
        now: Date.now(),
      });
    }, 60000);
  }
  componentWillUnmount() {
    clearInterval(this.ticker);
  }
  render() {
    // Filter in JS rather than GraphQL which is run at build time so the site
    // can change without a re-deploy.
    const { now } = this.state;
    const announcements = unwrapQuery(this.props.data.announcements).filter(
      (banner) =>
        new Date(banner.visibleStartDate) < now &&
        new Date(banner.visibleEndDate) > now,
    );
    if (announcements.length === 0) {
      return null;
    }
    return (
      <div className="SiteAnnouncements">
        {announcements.map((announcement) => (
          <div className="SiteAnnouncements-announcement" key={announcement.id}>
            <Link
              to={announcement.url}
              external
              className="SiteAnnouncements-announcement-content"
            >
              <span className="SiteAnnouncements-announcement-content-title">
                {announcement.title}
              </span>
              <span className="SiteAnnouncements-announcement-content-details">
                {announcement.details}
              </span>
            </Link>
          </div>
        ))}
      </div>
    );
  }
}
export default () => (
  <StaticQuery
    query={graphql`
      {
        announcements: allAnnouncementsYaml(
          filter: { position: { eq: "banner" }, enabled: { eq: true } }
        ) {
          edges {
            node {
              id
              visibleStartDate
              visibleEndDate
              title
              details
              url
            }
          }
        }
      }
    `}
    render={(data) => <SiteAnnouncements data={data} />}
  />
);
